import React from 'react';
import {Places} from './../../configurations/Places';
import './SmileCenters.css';
import smileCenterHeader from './../../assets/img/smileCenterHeader.png'
import StateSmileCenter from '../Components/Presentation/StateSmileCenter/StateSmileCenter';
import Maps from './../Components/Presentation/Maps/Maps';
import locationIcon from './../../assets/img/location.svg';

class SmileCenters extends React.Component {

    constructor(){
        super();
        this.state = {
            state: "CDMX",
            name: "Polanco",
            address: "Jaime Balmes 11, local 146, 1er piso. Polanco I Sección",
            image: "polanco"
        }
    }

    getSites = (sites) =>{
        let sitesList = sites.map((site) => {
            return (
                <div className="col-md-12 site-container">
                    <p className="site-title"><i className="pe-7s-map-marker"></i>{site.name}</p>
                    <p className="direction">{site.address}</p>
                </div>
            )
        });
        return sitesList;
    }

    changeState = (state) => {
        this.setState({state: state});
    }

    changeCenter = (center) => {
        let location = this.getCenter(this.state.state, center);
        this.setState({
            name: location.name, 
            address: location.address,
            image: location.image
        });
    }

    getCenter = (state, center) => {
        let centers = null;
        Places.forEach((item) => {
            if(item.state === state){
                centers=item.locations;
                return;
            }
        });

        let location= null;
        if(centers !== null){
            centers.forEach((item) =>{
                if(item.name === center){
                    location = item;
                }
            });
        }
        return location;
    }

    render() {
        const states= Places.map((location)=> {
            // const sites= this.getSites(location.locations);
            return (
                <StateSmileCenter 
                    clickHandler={this.changeState}
                    state={location.state}
                />
            )
        });

        const {state = "CDMX", name, address, image } = this.state;
        let centers = null;
        Places.forEach((item) => {
            if(item.state === state){
                centers=item.locations;
                return;
            }
        });

        let centersItems= null;
        if(centers !== null){
            centersItems = centers.map((item)=> {
                return (<StateSmileCenter
                    clickHandler={this.changeCenter}
                    state={item.name}
                />)
            });
        }

        return (
            <div class="container smilecenter-container">
                <div className="row smilecenter header">
                    <div className="col-md-5 col-md-offset-1">
                        <h4 className="title">Centros de escaneo</h4>
                    </div>
                    <div className="col-md-6 text-right smilecenter headerimagecontainer">
                        <img className="img-responsive smilecenter headerimage" alt="moons" src={smileCenterHeader}></img>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-3">
                        <ul>
                            {states}
                        </ul>
                    </div>
                    <div className="col-md-3">
                        <ul>
                            {centersItems}
                        </ul>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-2 text-center">
                                <img src={locationIcon}/>
                            </div>
                            <div className="col-md-6">
                                <p className="smilecenter name">{name}</p>
                                <p className="smilecenter location">{address}</p>
                            </div>
                        </div>
                            
                        <div className="vertical-separator-30px"></div>
                            
                        <div className="row">
                            <div className="col-md-12">
                                <Maps
                                    place={image}
                                ></Maps>
                            </div>
                        </div>
                    </div>
                </div>
            
                <div className="vertical-separator-30px"></div>
            </div>

        )
    }

}

export default SmileCenters;



// WEBPACK FOOTER //
// ./src/views/SmileCenters/SmileCenters.js